import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import useTheme, { resolveTheme } from "@/hooks/stores/useTheme";
import ThemeToggle from "@/components/ThemeToggle";
import useAuth from "@/hooks/stores/useAuth";

export function FullScreenLayout() {
  const { theme } = useTheme();
  const resolvedTheme = resolveTheme(theme);
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-background text-foreground">
      {isAuthenticated ? (
        <div className="flex">
          <div className="flex-1">
            <main className="mx-auto">
              <Outlet />
            </main>
          </div>
        </div>
      ) : (
        <main className="mx-auto px-4 py-8">
          <Outlet />
        </main>
      )}

      <div className="fixed bottom-5 right-5 z-50">
        <ThemeToggle />
      </div>
      <Toaster theme={resolvedTheme} richColors />
    </div>
  );
}
